import * as wjcCore from '@grapecity/wijmo';
import * as wjMultirow from '@grapecity/wijmo.grid.multirow';
import * as wjGridFilter from '@grapecity/wijmo.grid.filter';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjInput from 'wijmo/wijmo.input';
import * as uuid from 'uuid';

declare var Stimulsoft: any;
'use strict';

import {HostListener, ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {saveAs} from 'file-saver';
import {ModalDirective} from "ngx-bootstrap/modal";
import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import {ConfirmComponent} from "../ui/modal";
import {GapiSession} from "../gapi/gapi.session";
import {WhiteboardComponent} from "../ui/whiteboard/whiteboard.component";

@Component({
    selector: 'cj-user-measure',
    templateUrl: 'measure.component.html',
})

export class MeasureComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('measureGrid') measureGrid: wjMultirow.MultiRow;
    @ViewChild('removeMeasurePopup') removeMeasurePopup: ConfirmComponent;
    filter: wjGridFilter.FlexGridFilter;
    fromDate: any;
    toDate: any;
    keyword: string = "";
    measureDefinition: any;
    screenWidth: number;
    carts: any[] = [];
    departments: any[] = [];
    measureTypes: any[] = ["靴・鞄","総重量","袋"];
    measure: any = {};
    measures: OrientDBCollectionView;
    mode: string = "view";

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private gapiSession: GapiSession) {
        this.measures = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, "SELECT FROM AP_Measure", "AP_Measure", "", 0, 100, true, true, false)
        this.measures.url = KaitoriyaConfig.SERVER_URL;
        this.measures.tokenName = KaitoriyaConfig.DATABASE + "_token";
        this.measures.sortDescriptions.push(new wjcCore.SortDescription("id", false));
        this.createNew();
        this.resizeScreen();
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='計量区分' order by sort",
            count:  "SELECT FROM AP_Master WHERE category ='計量区分' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.departments = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='カゴ車' order by sort",
            count:  "SELECT FROM AP_Master WHERE category ='カゴ車' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.carts = data.results;
            }
        })
    }

    ngAfterViewInit() {
        this.filter = new wjGridFilter.FlexGridFilter(this.measureGrid);
        this.measures.currentChanged.addHandler(this.onCurrentChanged, this);
        this.measures.itemsSourceFunction = this.measureItemsSourceFunction.bind(this);
        this.measures.filterOnServer = true;
    }

    //@HostListener('window:resize', ['$event'])
    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth >= 768) {
            this.measureDefinition =
                [
                    {
                        cells: [
                            {binding: 'id', header: '番号', dataType: 'Number', width: 80}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'measureDate', header: '計量日', dataType: 'Date', format: "yyyy/MM/dd", width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'department', header: '部門', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'measureType', header: '対象', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'cart', header: 'カゴ車', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'weight', header: '重量', dataType: 'Number', width: 80}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'memo', header: 'メモ', width: 200}
                        ]
                    }
                ];
        } else {
            this.measureDefinition =
                [
                    {
                        cells: [
                            {binding: 'id', header: '番号', width: 60},
                        ]
                    },
                    {
                        colspan: 2,
                        cells: [
                            {binding: 'department', header: '部門', width: 100},
                            {binding: 'measureType', header: '対象', width: 100},
                            {binding: 'measureDate', header: '計量日', dataType: 'Date', format: "MM/dd", width: 100},
                            {binding: 'cart', header: 'カゴ車', width: 100},
                            {binding: 'weight', header: '重量', dataType: 'Number', width: 100},
                            {binding: 'memo', header: 'メモ'}
                        ]
                    }
                ];
        }
    }

    search(): void {
        let where = [];
        if (!wjcCore.isNullOrWhiteSpace(this.keyword)) {
            where.push("memo LIKE '%" + this.keyword + "%'");
        }
        if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
            where.push("(measureDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
        } else {
            if (wjcCore.isDate(this.fromDate)) {
                where.push("measureDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
            }
            if (wjcCore.isDate(this.toDate)) {
                where.push("measureDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
            }
        }
        this.measures.filterOnServer = false;
        this.measures.filterSpecial = where.join(" OR ");
        this.measures.filterOnServer = true;
    }

    createNew(): void {
        var today = new Date();
        var measureDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.measure = {
            "@class": "AP_Measure",
            "@rid": "#-1:-1",
            measureDate: measureDate,
            measureType: "総重量",
            cart: "なし",
            weight: 0,
            uuid: uuid.v4().split("-").join(""),
            memo: "",
            department: "SS"
        }
    }

    measureItemsSourceFunction(items: any[]) {
        for (let item of items) {
            this.convertMeasure(item);
        }
        return items;
    }

    convertMeasure(item: any): void {
        if (isOrientDate(item.measureDate)) {
            item.measureDate = asOrientDate(item.measureDate);
        }
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (!!this.measures.currentItem && this.mode == "view") {
            this.measure = this.measures.currentItem;
        }
    }

    saveMeasure(): void {
        let measure = {...this.measure};
        if (wjcCore.isDate(measure.measureDate)) {
            measure.measureDate = wjcCore.Globalize.formatDate(measure.measureDate, 'yyyy-MM-dd');
        }
        let sql = "BEGIN\n"
        let mapHead = [];
        Object.entries(measure).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                mapHead.push(key + "=" + value)
            } else {
                if (!key.startsWith("@") && value != null)
                    mapHead.push(key + "='" + value + "'")
            }
        });
        if (measure['@rid'] == "#-1:-1") {
            sql = sql + "let measure = INSERT INTO AP_Measure SET id = sequence('measure').next(), " + mapHead.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE AP_Measure SET " + mapHead.join(",") + " WHERE @rid = " + this.measure['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
            this.toasterService.pop('info', '保存', '保存されました。');
            this.dataService.query({
                sql: "SELECT FROM AP_Measure WHERE uuid = '" + this.measure.uuid + "'",
                count: "SELECT FROM AP_Measure WHERE uuid = '" + this.measure.uuid + "'",
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                if (data.results.length == 1) {
                    this.measure = data.results[0];
                    this.convertMeasure(this.measure);
                    this.mode = "view";
                }
            })
        }, (error: any) => {
            this.toasterService.pop('error', '保存', '失敗しました。');
        })
    }

    confirmRemoveMeasure(): void {
        this.removeMeasurePopup.modal.show();
    }

    removeMeasure(): void {
        let command = "DELETE VERTEX " + this.measure['@rid'];
        this.dataService.command({sql: command}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', '削除', '削除されました。');
                this.mode = "view";
                this.measures.queryData();
                this.toTopMeasure();
            },
            (error) => {
                this.toasterService.pop('error', '削除', '失敗しました。');
            })
    }

    toTopMeasure(): void {
        this.measures.moveCurrentToFirst();
        if (!!this.measures.currentItem && this.mode == "view") {
            this.measure = this.measures.currentItem;
        }
    }

    export(grid: string, name: string) {
        if (this[grid] instanceof wjMultirow.MultiRow)
            wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this[grid] as wjMultirow.MultiRow, {includeColumnHeaders: true, includeCellStyles: false}, name + '.xlsx');
    }

}

